import { __decorate, __metadata } from "tslib";
import { IsEnum, IsString, IsUUID, Length, ValidateIf } from 'class-validator';
import { PagedQuery } from '../core';
export const SEARCH_MIN_LENGTH = 3;
export const SEARCH_MAX_LENGTH = 250;
/**
 * Search types available in our search API
 */
export var SingleEntitySearchRequestType;
(function (SingleEntitySearchRequestType) {
    SingleEntitySearchRequestType["ThisRecording"] = "this recording";
    SingleEntitySearchRequestType["ThisAudioSegment"] = "this audio segment";
})(SingleEntitySearchRequestType || (SingleEntitySearchRequestType = {}));
/**
 * Requests a search with the provided <code>courtSystemId</code> and <code>searchTerms</code>
 */
export class SingleEntitySearchRequest extends PagedQuery {
}
__decorate([
    IsUUID(),
    __metadata("design:type", String)
], SingleEntitySearchRequest.prototype, "courtSystemId", void 0);
__decorate([
    IsString(),
    __metadata("design:type", Object)
], SingleEntitySearchRequest.prototype, "timeZoneId", void 0);
__decorate([
    Length(SEARCH_MIN_LENGTH, SEARCH_MAX_LENGTH),
    __metadata("design:type", String)
], SingleEntitySearchRequest.prototype, "searchTerms", void 0);
__decorate([
    IsEnum(SingleEntitySearchRequestType),
    __metadata("design:type", String)
], SingleEntitySearchRequest.prototype, "searchType", void 0);
__decorate([
    ValidateIf(r => r.searchType === SingleEntitySearchRequestType.ThisRecording),
    IsUUID(),
    __metadata("design:type", String)
], SingleEntitySearchRequest.prototype, "recordingId", void 0);
__decorate([
    ValidateIf(r => r.searchType === SingleEntitySearchRequestType.ThisAudioSegment),
    IsUUID(),
    __metadata("design:type", String)
], SingleEntitySearchRequest.prototype, "audioSegmentId", void 0);
